angular.module('rjmNg.directives').directive "magentoSignup", [
  "notification"
  "$timeout"
  "Signups"
  "Billing"
  "$location"
  "$routeParams"
  (notification, $timeout, Signups, Billing, $location, $routeParams) ->
    restrict: "E"
    templateUrl: "directive.signup.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    require: "^?rjmUi"
    controller: [
      "COUNTRIES"
      (COUNTRIES) ->

        statusPollPromise = null
        errorMessage = "We ran into a problem creating your account.  Please contact <a href='https://support.rjmetrics.com/hc/en-us/requests/new' target='_blank'>support</a>."

        view = @

        view.selectedPricingTier = false
        view.loading = false

        view.gmvBuckets = null
        view.selectedBucket = null
        view.countries = COUNTRIES

        Billing.getTiers()
        .then (response) ->
          view.gmvBuckets = response
          view.selectedBucket = view.gmvBuckets[0]

        view.signup =
          email: null
          first_name: null
          last_name: null
          role: null
          company: null
          country: null

        if $routeParams.connection_id?
          view.signup.connection_id = $routeParams.connection_id
        if $routeParams.token?
          view.signup.token = $routeParams.token
        if $routeParams.customer_id? and
          $routeParams.subscription_id? and
          $routeParams.subscription_type? and
          $routeParams.signature?
            view.selectedPricingTier = true
            view.signup.magento =
              customer_id: $routeParams.customer_id
              subscription_id: $routeParams.subscription_id
              subscription_type: $routeParams.subscription_type
              signature: $routeParams.signature
        else
          view.signup.tier = null

        view.responseErrors = null
        view.submittedSignupForm = false

        view.saveTierSelection = () ->
          view.selectedPricingTier = true
          view.signup.tier = view.selectedBucket.id

        pollStatus = (statusUrl) ->
          Signups.status(statusUrl)
          .then (response) ->
            if response.status is "completed"
              view.submittedSignupForm = true
              view.loading = false
              if response.pubkey?
                $location.path("/magento/login").search {email:encodeURIComponent(view.signup.email)}
            else
              $timeout ->
                pollStatus statusUrl
              , 5000

        view.submitForm = () ->
          view.loading = true
          Signups.create(view.signup)
          .then (response) ->
            notification.clearAll()
            pollStatus(response.id)
          .catch ({data}) ->
            notification.error("Signup failed.", errorMessage, "signup", { dismissable: false, bindHtml: true })
            view.loading = false

        view
    ]

    link: (scope, element, attributes, rjmUi) ->
      scope.$watch "view.loading", () ->
        rjmUi?.loadingUi "magentoSignup", scope.view.loading, "Setting up your account"
]
